import * as constants from './constants'

export default (state = {}, action) => {
    let newState

    switch (action.type) {
        case constants.GET_HISTORY_START:
            newState = {
                ...state,
                loading: true,
                token: '',
                error: false,
            }
            break
        case constants.GET_HISTORY_SUCCESS:
            {
                const { payload } = action

                const conversation = payload?.conversation || []
                const unsubscribed = payload?.unsubscribed
                const token = payload?.token || ''
                const { statusOn } = payload
                const { crmStatus } = payload
                newState = {
                    ...state,
                    loading: false,
                    conversation,
                    token,
                    statusOn,
                    crmStatus,
                    unsubscribed,
                }
            }
            break
        case constants.GET_HISTORY_FAIL:
            {
                const { payload: error } = action

                newState = {
                    ...state,
                    error,
                    loading: false,
                    conversation: [],
                }
            }
            break
        case constants.GET_STATUSES_START_REPLY:
            newState = {
                ...state,
                loadingStatuses: true,
            }
            break
        case constants.GET_STATUSES_SUCCESS_REPLY:
            {
                const { payload } = action

                console.log('payload: ', payload)
                newState = {
                    ...state,
                    loadingStatuses: false,
                    statuses: payload,
                }
            }
            break
        case constants.GET_STATUSES_FAIL_REPLY:
            newState = {
                ...state,
                loadingStatuses: false,
                statuses: [],
            }
            console.log('FAILED FETCHING STATUSES')
            break
        case constants.CREATE_MESSAGE_START:
            newState = {
                ...state,
                sendingProgress: true,
            }
            break
        case constants.CREATE_MESSAGE_SUCCESS:
            newState = {
                ...state,
                sendingProgress: false,
            }
            // {
            //     const { payload } = action
            //     let { conversation } = state

            //     if (payload) {
            //         const exists = conversation
            //             .find((element) => element.MessageId === payload.MessageId)

            //         if (!exists) {
            //             conversation = [
            //                 ...conversation,
            //                 payload
            //             ]
            //         }
            //     }
            // }
            break
        case 'TESTCONVO':
            newState = {
                ...state,
                testSuccess: true,
            }

            break

        case constants.CREATE_MESSAGE_FAIL:
            newState = {
                ...state,
                sendingProgress: false,
            }
            break
        case constants.USER_NEW_MESSAGE:
            {
                const { payload } = action
                let { conversation = [] } = state
                console.log('USER NEW MESSAGE payload:', payload)
                console.log('USER NEW MESSAGE conversation:', conversation)

                if (payload) {
                    const exists = conversation.find(
                        element => element.MessageId === payload.MessageId
                    )

                    if (!exists) {
                        conversation = [...conversation, payload]
                    }
                }

                newState = {
                    ...state,
                    conversation,
                }
            }
            break
        case constants.GET_STOPBOTEVENTS_SUCCESS:
            newState = {
                ...state,
                stopBotEvents: action.payload.Items || [],
            }
            break
        default:
            newState = state
            break
    }

    return newState
}
